import CryptoTool from './../../../tools/CryptoTool'

export var middlewareUserAuth = (to, from, next) => {
    let client_id = CryptoTool.decrypt(localStorage.getItem('client_id'))

    if (!client_id) {
        next({name: 'user.login', query: {next: to.name}})
    } 
    next()
}

export var middlewareUserNotConnect = (to, from, next) => {
    let client_id = CryptoTool.decrypt(localStorage.getItem('client_id'))

    if (client_id) {
        next({name: 'home'})
    }
    next()
}

export var middlewareUserHome = (to, from, next) => {
    let client_id = CryptoTool.decrypt(localStorage.getItem('client_id'))

    if (!client_id) {
        next({name: 'welcome'})
    }
    next()
}



// WEBPACK FOOTER //
// ./src/companies/default/router/Middlewares.js